import { TemplatePage } from './types';

const live_streaming_us_theme: TemplatePage = {
  header: {
    color: '#ED8A77',
    icon: 'images/video-templates/us_theme.jpg',
    title: 'Live Stream Templates — US Theme',
    title_meta: '10+ Free Live Stream Overlay Templates — US Theme',
    description_meta:
      'Make your live streams look and feel highly professional with Wave.video’s pack of ' +
      'customizable US-themed templates.',
    description:
      'Make your live streams look and feel highly professional with our customizable US-themed ' +
      'templates. Get a set of fantastic-looking overlays, transition screens, and frames that perfectly fit' +
     ' multistreaming services like' +
      ` <a href=https://wave.video/live-streaming/streaming-software class="blackLink">Wave.video Live Streaming Studio</a>.`
  },
  footer: {
    category: 'Live Stream US Theme',
    description:
      'With Wave.video’s exclusive themed collections of easy-to-edit overlay and transition screen ' +
      'templates, you will easily amaze your live stream viewers and boost your fanbase! Create eye-catching ' +
      'thumbnails, countdowns, intros, lower thirds, and technical issue screens in a matter of minutes. Becoming ' +
      'a professional live streamer has never been easier!'
  },
  content: [
    {
      type: 'templates',
      title: 'US Theme templates',
      search: { tags: 'USTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_us_theme;
